// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__TI7V_","text":"SelectPayment_text__122Oz","title":"SelectPayment_title__wngDm","btn":"SelectPayment_btn__29UPP"};